
'format es6';

import Promise from 'Promise';
import gsap from 'greensock';
import ns from 'ns';
import $ from 'jquery';
import User from '../User';
import Api from '../Api';
import Store from 'store';
import Scroll from '../Scroll';

import { factory as sectionFactory } from './Section';
import { factory as profileDomainFactory } from './ProfileDomain';
import { factory as pubFactory } from './Pub';

require('../../views-compiled/profile');

const EASING = gsap.Expo;
const PROFILE_RESULT_KEY = 'user.profile_result';
const REQUESTED_PROFILE_RESULT_KEY = 'requested_profile_result';
const SHOW_ROLLBACK_KEY = 'show_rollback';
const QUESTIONS_STATS = 'profile_questions_stats';

function ProfileResult() {

	this.templateName = 'profile.htm';

	let domains;
	let domainsCta;
	let detailsContainer;

	let result;
	this.setResult = (vals) => {
		result = vals;
	};

	let qstats;
	this.setStats = (vals) => {
		qstats = vals;
	};

	this.setAnimation = (tl, rootNode, setInEndTime) => {
		tl.from(rootNode, 0.3, { opacity: 0, ease: EASING.easeIn });
		const animateInFinish = setInEndTime();
		tl.to(rootNode, 0.3, { opacity: 0, ease: EASING.easeOut }, animateInFinish);
		return tl;
	};

	this.init = () => {
		const domainPromise = Api.request(`domains/${ns.lang}`);

		return domainPromise.then((loadedData) => {
			domains = loadedData.map(domainData => {
				const domainRes = result.find(r => r.id == domainData.id);
				domainData.prc = domainRes && Math.ceil(domainRes.ratio * 100);
				domainData.ratio = domainRes.ratio;
				domainData.letter = ns.domainLetters.get(`${domainData.id}_${ns.lang}`);
				domainData.slug = ns.domainSlugs.get(`${domainData.id}_${ns.lang}`);
				return domainData;
			});

			domains.sort((d1, d2) => d2.prc - d1.prc);
			User.set(PROFILE_RESULT_KEY, domains);
			ns.Menu.updateData();

			if (qstats) {
				User.set(QUESTIONS_STATS, qstats);
			}

			return { domains };
		});
	};

	let currentDisplayedDomain;
	const renderDomainDetails = (domainId) => {
		domainsCta.off('click.cursus');

		// Define onOut to always be a Promise to be then-able
		const onOut = (currentDisplayedDomain && currentDisplayedDomain.animateOut()) || Promise.resolve();

		onOut.then(() => {
			// Create a new profileDomain view
			currentDisplayedDomain = profileDomainFactory();
			currentDisplayedDomain.setData(domains.find(domain => domain.id === domainId));

			const onReady = currentDisplayedDomain.render(detailsContainer);
			onReady.then(() => {
				currentDisplayedDomain.animateIn();

				if (ns.isMobile()) {
					Scroll.moveToContent(detailsContainer, $('#header').height());
				}

				domainsCta.on('click.cursus', domainCtaClick);
				currentDisplayedDomain.onClickNext((e) => {
					e.preventDefault();
					const clicked = $(e.currentTarget);
					const requestedDomain = domains.find(domain => domain.id === String(clicked.data('domain-id')));

					this.animateOut().then(() => {
						this.next && this.next(requestedDomain);
					});
				});
			});
		});
	};

	const domainCtaClick = (e) => {
		const clicked = $(e.currentTarget);
		const domainId = String(clicked.data('domain-cta'));

		domainsCta.find('.domain-name').removeClass('current-item');
		clicked.find('.domain-name').addClass('current-item');
		renderDomainDetails(domainId);
	};

	this.activateCtas = () => {
		domainsCta.on('click.cursus', domainCtaClick);

		let cta = domainsCta.eq(0);

		// If we are coming to this section by another one (example the menu),
		// thus targeting a specific domain
		if (Store.get(REQUESTED_PROFILE_RESULT_KEY) != null) {
			cta = domainsCta.filter(`[data-domain-cta="${Store.get(REQUESTED_PROFILE_RESULT_KEY)}"]`);
		}

		cta.trigger('click');
		Store.remove(REQUESTED_PROFILE_RESULT_KEY);

		if (Store.get(SHOW_ROLLBACK_KEY)) {
			$.magnificPopup.open({
				items: {
					src: '#rollback-popup',
				},
				type: 'inline',
			});

			$('#close-instructions').on('click.udem', () => {
				$.magnificPopup.close();
			});

			Store.remove(SHOW_ROLLBACK_KEY);
		}
	};

	this.activate = () => {
		detailsContainer = $('[data-domain-desc]', this.sectionNode);
		domainsCta = $('[data-domain-cta]', this.sectionNode);

		// Animate progress bars
		const progressBars = domainsCta.find('.progress');
		progressBars.each((i, el) => {
			const $el = $(el);
			gsap.TweenMax.to($el, 1, { width: $el.data('width'), delay: 0.5 * i });
		});

		// If we have not seen a publicity yet and we are not 
		// on mobile, then we will create and render one.
		// Once the pub has finished, activate CTAs and thus 
		// render the domain needed.
		if (ns.previousPubs === undefined && !ns.isMobile()) {
			const pub = pubFactory();
			pub.setData();
			pub.render(detailsContainer).then(() => {
				pub.animateIn();
				pub.onNext(() => {
					this.activateCtas();
				});
			});
		} else {
			$('[data-load-title]').css('opacity', 1);
			this.activateCtas();
		}
	};

	this.deactivate = () => {
		domainsCta.off('.cursus');
	};

	return this;
}


export function factory(instance) {
	return ProfileResult.call(sectionFactory(instance || {}));
}
